/* https://github.com/feross/fromentries
   fromentries. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> 
    
   Use this instead of Object.fromEntries
*/

export function fromEntries<T = any>(entries: Iterable<readonly [PropertyKey, T]>): { [k: string]: T } {
  return [...entries].reduce((obj, [key, val]) => {
    obj[key as string] = val;
    return obj;
  }, {} as { [k: string]: T });
}
